import { VoiceAirMetricDefinition } from './voice-air-metrics.types';
import { voiceAirFlagsMetric } from './metrics/voice-air-flags';
import { truelarkBusinessIdMetric } from './metrics/truelark-business-id';
import { tenDlcRegisteredMetric } from './metrics/ten-dlc-registered';
import { businessPreferencesMetric } from './metrics/business-preferences';
import { schedulingServiceTypeMetric } from './metrics/scheduling-service-type';
import { providerOperatoryAvailableMetric } from './metrics/provider-operatory-available';
import { phoneOfficeHoursMetric } from './metrics/phone-office-hours';
import { aiMissedCallTextMetric } from './metrics/ai-missed-call-text';
import { voiceAiRoutingMetric } from './metrics/voice-ai-routing';
import { routingForwardingActivityMetric } from './metrics/routing-forwarding-activity';
import { voiceAiTasksReviewedMetric } from './metrics/voice-ai-tasks-reviewed';

export const VOICE_AIR_METRIC_DEFINITIONS: VoiceAirMetricDefinition[] = [
  voiceAirFlagsMetric,
  truelarkBusinessIdMetric,
  tenDlcRegisteredMetric,
  businessPreferencesMetric,
  schedulingServiceTypeMetric,
  providerOperatoryAvailableMetric,
  phoneOfficeHoursMetric,
  aiMissedCallTextMetric,
  voiceAiRoutingMetric,
  routingForwardingActivityMetric,
  voiceAiTasksReviewedMetric,
];
